import * as React from 'react'
import styled from 'styled-components'
import CloseIcon from 'assets/menu-close.svg'
import theme from 'theme'
import useTranslations from 'hooks/useTranslations'

type Props = {
  onClose: () => void
  'data-cy-state': string
}

export function DeliveryInfoModal(props: Props) {
  const t = useTranslations<'molecules-account-CartSummary'>()
  return (
    <Wrapper
      className="DeliveryInfoModal"
      data-cy-state={props['data-cy-state']}
    >
      <div className="box">
        <div
          className="close-wrapper"
          onClick={props.onClose}
          data-cy-handle="popup-close"
        >
          <CloseIcon />
        </div>
        <h2 className="title">{t('deliveryinfomodal_shippingcost')}</h2>
        <div className="deliveryinfo">
          {t('deliveryinfomodal_shippingcost_text')}
        </div>
      </div>
    </Wrapper>
  )
}

export default DeliveryInfoModal

const Wrapper = styled.div`
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: ${theme.zIndex
    .theme_molecules_account_cartsummary_deliveryinfomodal};
  cursor: pointer;
  position: fixed;
  > .box {
    position: fixed;
    max-width: 600px;
    width: 100%;
    padding: 40px;
    background: whitesmoke;
    z-index: ${theme.zIndex
      .theme_molecules_account_cartsummary_deliveryinfomodal_Box};
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    > .title {
      ${theme.ty('rc-2xl', '700')};
      margin: 10px;
    }
    > .deliveryinfo {
      ${theme.ty('r-base', '700')};
    }
    > .close-wrapper {
      position: absolute;
      top: 20px;
      right: 20px;
      cursor: pointer;
    }
  }
`
